import React, { useState } from 'react';
import { HelpCircle } from 'lucide-react';
import { SimpleUserManual } from './SimpleUserManual';

export const HelpButton: React.FC = () => {
  const [isManualOpen, setIsManualOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsManualOpen(true)}
        className="fixed bottom-4 left-4 sm:bottom-6 sm:left-6 z-[100] bg-gradient-to-r from-[#0da5e1] to-[#0da5e1]/90 hover:from-[#0da5e1]/90 hover:to-[#0da5e1] text-white p-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 hover:-translate-y-1"
        title="Open User Manual"
        aria-label="Open User Manual"
      >
        <HelpCircle className="h-5 w-5" />
      </button>

      <SimpleUserManual 
        isOpen={isManualOpen} 
        onClose={() => setIsManualOpen(false)} 
      />
    </>
  );
};